export { PickUpItemsFeature } from './ui';
